"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getId = void 0;
function hasId(val) {
    return val.id !== undefined;
}
function getId(val) {
    if (hasId(val)) {
        return val.id;
    }
    return val;
}
exports.getId = getId;
//# sourceMappingURL=Identifiable.js.map